// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2bB4-","itemTitle":"ClientEmergencyInfo_itemTitle__3SdEs","itemText":"ClientEmergencyInfo_itemText__EHpVF"};